/** public/images/hero — BASE_URL 付きでサブパス配信でも解決 */
export function publicHeroFile(name: string) {
  return `${import.meta.env.BASE_URL}images/hero/${name}`.replace(/\/+/g, '/');
}

export function punchingMetalBackgroundImage() {
  return `image-set(url("${publicHeroFile('panching_metal.jpg')}") 1x, url("${publicHeroFile('panching_metal@2x.jpg')}") 2x)`;
}
